import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de Actividad de Cuenta
 * - Ãšltimos accesos, cambios recientes, logs propios
 * - Extensible para integraciÃ³n con sistema de auditorÃ­a
 */
export default function AccountActivitySection() {
    return (
        <Box>
            <Typography variant="h6">Actividad de Cuenta</Typography>
            {/* TODO: VisualizaciÃ³n de logs personales */}
            <Typography variant="body2" color="text.secondary">
                Revisa tus Ãºltimos accesos y cambios recientes en tu cuenta.
            </Typography>
        </Box>
    );
} 